export class GetActionApprovalRuleResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actionApprovalRule",
            "baseName": "actionApprovalRule",
            "type": "ActionApprovalRule",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetActionApprovalRuleResponse.attributeTypeMap;
    }
    constructor() {
    }
}
